<template>
  <div class="menu-wrapper">
    <MenuBlock
      v-for="(menu, index) in separatedMenuItems.withChild"
      :key="index"
      :menu="menu"
    />
    <MenuBlock
      v-if="separatedMenuItems.withoutChild.children.length > 0"
      :menu="separatedMenuItems.withoutChild"
    />
  </div>
</template>

<script>
import MenuBlock from './MenuBlock';
export default {
  name: 'MenuList',
  components: { MenuBlock },
  props: {
    menuItems: {
      type: Array,
      required: true,
    },
  },

  computed: {
    separatedMenuItems () {
      return this.menuItems.reduce((result, currentMenu) => {
        if ((currentMenu.children || []).length === 0) {
          result.withoutChild.children.push(currentMenu);
        } else {
          currentMenu.path += '/';
          result.withChild.push(currentMenu);
        }

        return result;
      }, { withChild: [], withoutChild: { displayName: this.$t('unauthorized.menuTitle.others'), children: [], path: '' } });
    },
  },
};
</script>

<style lang="scss" scoped>
  .menu-wrapper {
    display: flex;
    flex-wrap: wrap;
  }
</style>
